var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { matchPath } from 'react-router';
import { SideBarNavigation } from '../navigation';
import MainSideBar from './MainSideBar';
import { SideBarVisible } from './styles';
var MainSideBarContainer = function (_a) {
    var location = _a.location, org = _a.org, _b = _a.routeProps, routeProps = _b === void 0 ? {} : _b, role = _a.role, 
    // devPlanConsume,
    navigate = _a.navigate;
    var sidebar = SideBarNavigation(org.selectedOrganizationId) || {};
    var PartnerMenuItems = sidebar.secondaryMenus.partnerMenu.map(function (item) { return (__assign(__assign({}, item), { isActive: Boolean(matchPath(location.pathname, item.activationPathMatch)), onClick: function (innerItem) {
            var path = innerItem.slug;
            navigate("".concat(path));
        }, children: item.children
            ? item.children.map(function (child) { return (__assign(__assign({}, child), { onClick: function (innerItem) {
                    var path = innerItem.slug;
                    navigate("".concat(path));
                }, isActive: Boolean(matchPath(location.pathname, child.activationPathMatch)) })); })
            : null })); });
    var OrganizationMenuItems = sidebar.secondaryMenus.organizationMenu.map(function (item) { return (__assign(__assign({}, item), { isActive: Boolean(matchPath(location.pathname, item.activationPathMatch)), onClick: function (innerItem) {
            var path = innerItem.slug;
            navigate("".concat(path));
        } })); });
    var isSecondaryMenuVisible = location.pathname.indexOf('partner') > -1 ||
        location.pathname.indexOf('system') > -1 ||
        (location.pathname.indexOf('organizations/') > -1 &&
            !location.pathname.includes('organizations/new'));
    var secondaryMenuType = '';
    if (location.pathname.indexOf('partner') > -1) {
        secondaryMenuType = 'partner';
    }
    else if (location.pathname.indexOf('system') > -1) {
        secondaryMenuType = 'system';
    }
    else if (location.pathname.indexOf('organizations/') > -1) {
        secondaryMenuType = 'organizations';
    }
    var MainSideBarVisible = function () {
        return (_jsx(MainSideBar, __assign({}, routeProps, { role: role, secondaryMenuType: secondaryMenuType, secondaryMenuItems: secondaryMenuType === 'partner'
                ? PartnerMenuItems
                : secondaryMenuType === 'organizations'
                    ? OrganizationMenuItems
                    : sidebar.secondaryMenus.systemMenu })));
    };
    return (_jsx(SideBarVisible, { children: isSecondaryMenuVisible && MainSideBarVisible() }));
};
export default MainSideBarContainer;
